import Portico from '@ordernext/networking-stadium/portico'
import Stadium from '@ordernext/networking-stadium/stadium'
import PeripheralBridge from './peripheralBridge'
import toastSettings from './toastSettings'
import axios from 'axios'
import { authorizedRequest, CancelToken } from './authUtils'
import Log from './Log'
import Environment from './environment'
import smoothscroll from 'smoothscroll-polyfill'
import { configureNewAppVersionAvailable } from './newAppVersionAvailable'


const configureLogger = () => {
  Log.config = {
    verbose: Environment.app.isDevelopment
  }

  Log.adapter = {
    debug: (message, payload) => window.DD_LOGS && window.DD_LOGS.logger.debug(message, payload),
    info: (message, payload) => window.DD_LOGS && window.DD_LOGS.logger.info(message, payload),
    warning: (message, payload) => window.DD_LOGS && window.DD_LOGS.logger.warn(message, payload),
    error: (message, payload) => window.DD_LOGS && window.DD_LOGS.logger.error(message, payload),
    critical: (message, payload) => window.DD_LOGS && window.DD_LOGS.logger.error(message, payload),
  }
}

const configurePortico = () => {
  Portico.config = {
    baseURL: process.env.REACT_APP_OIDC_ISSUER,
  }
}

const configureStadium = () => {
  Stadium.config = {
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    },
  }
}

const configurePeripherals = () => {
  PeripheralBridge.setupWebViewJavascriptBridge(() => {})
}

const configureToast = () => {
  const root = document.getElementById('root')
  toastSettings.setAppElement(root)
  toastSettings.configureToast()
}

const configureAuthorizeRequest = () => {
  axios.interceptors.request.use(function (config) {
    const reqSource = CancelToken.source()

    if (!authorizedRequest(config?.url)) {
      reqSource.cancel('Invalid Token')
    }
    return config
  }, function (error) {
    return Promise.reject(error)
  })
}

const configurePolyfills = () => {
  smoothscroll.polyfill()
}

const configureServices = () => {
  const services = [
    configureLogger,
    configurePortico,
    configureStadium,
    configurePeripherals,
    configureToast,
    configureAuthorizeRequest,
    configurePolyfills,
    configureNewAppVersionAvailable,
  ]
  services.forEach((service) => service())
}

export default configureServices
